import { apiSlice } from "../api/apiSlice";

export const generatorChartReportApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getColoredOilLevelChartWithDate: builder.mutation({
      query: (data) => ({
        url: "/apiV2/generator/datetimeline",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetColoredOilLevelChartWithDateMutation } =
  generatorChartReportApi;
